import { Id } from "./id";

type ConfigurationProfile = {
  name: string;
  roles: Id[];
  columns: { key: string }[];
};

type WbsConfiguration = ConfigurationProfile[];

const wbsConfiguration: WbsConfiguration = [];

export type { WbsConfiguration };

export { wbsConfiguration };
